import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as Func from '../../../../../helpers/functions';
import i18n from "../../../../../constants/initLng";
import DEFINE, { UPLOAD_DIRECTORY, VALIDATE_ENUM, DETAIL_ACTIONS, FEATURE_FLAGS, PATHS, DATE_TIME_FORMAT } from '../../../../../constants/Define';
import * as HMS from "../../../common/component/Index";
import { message, Icon, Input as AntInput } from 'antd';
import AntSelect, { AntOption } from '../../../common/component/AntSelect'
import Input from '../../../common/component/Input';
import Wrapper from './../../../common/component/Wrapper';
import Button from './../../../common/component/Button';
import RichTextEditor, { ClassicEditor } from '../../../common/component/RichTextEditor';
import TextArea from '../../../common/component/TextArea';
import UploadImage from '../../../common/component/UploadImage';
import { omit, cloneDeep, merge, every, toArray, get, find } from 'lodash';
import TranslateButton from '../../../common/component/TranslateButton';
import TourTicket from '../../../../../models/TourTicket';
import Select, {Option} from '../../../common/component/Select';
import moment from 'moment';
// import './TourTicketDetail.less';

const defaultValue = {
    action: DETAIL_ACTIONS.CREATE,
    data: new TourTicket(),
    fileMultiple: [],
    isSubmit: false,
    isFetching: false,
    isFetchingUpdate: false,
    isGetItem: false,
    validation: {},
    isUpload: false,
    isUploadMultiple: false,
    thumbImage: {},
    listProperties: []
};
let permissionActions = [];
class TourTicketDetail extends Component {

    state = cloneDeep(defaultValue);

    componentDidMount() {
        const { match } = this.props;
        permissionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.TOUR_TICKET);
        this.props.onListAllProperties();
        this.setState({ fileMultiple: [] });
        if (Object.keys(match.params).length > 0) {
            this.setState({ action: DETAIL_ACTIONS.UPDATE, data: cloneDeep(defaultValue.data) });
            this.props.onGetUpdate({ id: match.params.id, props: this.props });
        }
    }

    validation = (field, reload) => {
        const { t, dataUpdate } = this.props;
        let data = this.state.data;
        let result = {};
        if (!reload) {
            let validate = {
                required: {
                    // ticketCode: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tourTicket.ticketCode`)),
                    name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tourTicket.name`)),
                    propertyId: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tourTicket.propertyName`))
                },
            };
            if (this.state.action === DETAIL_ACTIONS.CREATE) {
                validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
            }
            let valueValidate = {
                minImage: { images: 1 },
            };
            
            result = Func.multipleValidate(data, validate, valueValidate);
        } else {
            let validation = this.state.validation;
            result = Func.reloadValidation(validation, field)
        }
        this.setState({ validation: result });
        return result;
    };

    componentWillReceiveProps(nextProps) {
        this.setState({
            isSubmit: nextProps.tourTickets.isSubmit,
            isGetItem: nextProps.tourTickets.isGetItem,
            isUpload: nextProps.file.isFetching,
            isUploadMultiple: nextProps.file.isFetchingMultiple,
            isFetchingUpdate: nextProps.tourTickets.isFetchingUpdate
        })

        if(nextProps && nextProps.property) {
            this.setState({
                listProperties: nextProps.property.allProperties
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.tourTickets.detail !== prevProps.tourTickets.detail) {
            this.setState({
                data: this.props.tourTickets.detail.tourTicket
            })
        }
    }

    onChange = (e, tag) => {
        const data = this.state.data;
        if (tag) {
            data[tag] = e;
            this.setState({ data });
            this.validation(tag, true)
        } else {
            let params = Func.getValueForm(e);
            data[params.name] = typeof params.value === 'string' ? params.value.trimLeft() : params.value;
            this.setState({ data });
            this.validation(params.name, true)
        }
    };

    onSubmit = (e) => {
        e.preventDefault();
        let { action, data } = this.state
        let result = this.validation();
        if (Object.keys(result).length < 1) {
            let newData = this.state.data;

            if (action === DETAIL_ACTIONS.CREATE || action === DETAIL_ACTIONS.TRANSLATE) {
                this.saveTourTicket({ data: newData, props: this.props }, this.props.onCreateTourTicket);
            } else if (this.state.action === DETAIL_ACTIONS.UPDATE || action === DETAIL_ACTIONS.TRANSLATE) {
                let newData = this.state.data;
                if (typeof newData.thumbImage !== 'string') {
                    newData.thumbImage = undefined;
                }
                this.saveTourTicket({ data: merge(newData, { id: this.state.data.id }), props: this.props }, this.props.onUpdateTourTicket);
            }
        } else {
            message.error(i18n.t('validation.checkForm'))
        }
    };

    saveTourTicket = (params, updateFunc) => {
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onSaveTranslate(params.data)
        } else {
            updateFunc(params)
        }
    }

    onShowTranslate = (language) => {
        const { data } = this.state;
        data.setTranslate(language.code);
        data.setData();
        this.setState({ data, action: DETAIL_ACTIONS.TRANSLATE });
    }

    onExitTranslate = () => {
        const data = cloneDeep(this.state.data);
        const action = DETAIL_ACTIONS[data.id ? 'UPDATE' : 'CREATE'];
        data.setTranslate(undefined, true);
        data.setData();
        this.setState({ data, action });
    }

    onClickBack = () => {
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else {
            this.props.history.push(PATHS.TOUR_TICKET.LIST.path);
        }
    }

    onSaveTranslate = (data) => {
        data = data || this.state.data;
        const translateFunction = data.translate.id ? this.props.updateTourTicketTranslate : this.props.createTourTicketTranslate;
        translateFunction(data, data.languageCode);
        this.onExitTranslate();
    }

    onRemoveTranslate = (language) => {
        const { data } = this.state;
        data.setTranslate(language.code);
        this.props.deleteTourTicketTranslate(data, { id: data.id });
    }

    render() {
        const { t } = this.props;
        const { data, validation, isSubmit, isGetItem, action, listProperties, isUpload, file, checkData, isUploadMultiple } = this.state;
        
        return (
            <Fragment>
                <HMS.LoadingComponent spinning={isSubmit}>
                    <HMS.PageListComponent className="form-detail-page">
                        <HMS.HeaderListComponent
                            path={this.props.match.path}
                            groupPath={'tourTickets'}
                            titleHeader={
                                action === DETAIL_ACTIONS.CREATE ?
                                    Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.tourTicket.title')}`))
                                    : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.tourTicket.title')}`))
                            }
                            componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                                <TranslateButton
                                    languages={data.translations}
                                    current={data.languageCode}
                                    validation={validation.languageCode}
                                    onChange={this.onShowTranslate}
                                    onClear={this.onExitTranslate}
                                    defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                    onSelectDefault={language => this.onChange(language.code, 'languageCode')}
                                    onRemove={this.onRemoveTranslate} />
                            }
                        />
                        <HMS.FormActionComponent
                            onSubmit={this.onSubmit}
                            isSubmit={isSubmit}
                            isGetItem={isGetItem}
                            activeComponent={true}
                            onClickBack={this.onClickBack}
                            backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                            titleButtonSubmit={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.save`) : undefined}
                            submitButtonRight={true}
                        >
                            <HMS.FormWrapperItem>
                                { action !== DETAIL_ACTIONS.CREATE &&
                                    <div className={`col-md-6`}>
                                        <HMS.FormWrapperInputComponent
                                            isRequired={true}
                                            isValidation={true}
                                            dataValidation={data.ticketCode}
                                            validation={validation.ticketCode}
                                            labelTitle={t(`item.tourTicket.ticketCode`)}
                                            visible={false}
                                        >
                                            <Input type="text"
                                                autoComplete="off"
                                                className="form-control" name="ticketCode" onChange={this.onChange}
                                                value={data.ticketCode} />
                                        </HMS.FormWrapperInputComponent>
                                    </div>
                                }
                                <div className={`col-md-6`}>
                                    <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.name}
                                        validation={validation.name}
                                        labelTitle={t(`item.tourTicket.name`)}
                                    >
                                        <Input type="text"
                                            autoComplete="off"
                                            className="form-control" name="name" onChange={this.onChange}
                                            value={data.name} />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                <div className={`col-md-6`}>
                                    <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.propertyId}
                                        validation={validation.propertyId}
                                        labelTitle={t(`item.tourTicket.propertyName`)}
                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                    >
                                        <Select 
                                            className="form-control" 
                                            name="propertyId" 
                                            onChange={this.onChange}
                                            value={data.propertyId} required>
                                            <Option value="">Chọn cơ sở lưu trú</Option>
                                            {
                                                (listProperties && listProperties.length > 0) && listProperties.map((i, k) => {
                                                    return (
                                                        <Option value={i.id} key={k}>{i.name}</Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                <div className={`col-md-6`}>
                                    <HMS.FormWrapperInputComponent
                                        isValidation={true}
                                        dataValidation={data.shortDescription}
                                        validation={validation.shortDescription}
                                        labelTitle={t(`item.tourTicket.shortDescription`)}
                                    >
                                        <Input type="text"
                                            autoComplete="off"
                                            className="form-control" name="shortDescription" onChange={this.onChange}
                                            value={data.shortDescription} />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                <div className={`col-md-6`}>
                                    <HMS.FormWrapperInputComponent
                                        isValidation={true}
                                        dataValidation={data.description}
                                        validation={validation.description}
                                        labelTitle={t(`item.tourTicket.description`)}
                                    >
                                        <Input.TextArea rows={3} placeholder="" type={`text`}
                                                className='form-control'
                                                name='description' onChange={this.onChange}
                                                value={data.description} />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                <div className={`col-md-6`}>
                                    <HMS.FormWrapperInputComponent>
                                        <HMS.CheckboxComponent
                                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                            name='isAvailable'
                                            className={`mr-4`}
                                            onChange={this.onChange}
                                            checked={data.isAvailable}>{t(`item.tourTicket.isAvailable`)}
                                        </HMS.CheckboxComponent>
                                    </HMS.FormWrapperInputComponent>
                                </div>
                            </HMS.FormWrapperItem>
                        </HMS.FormActionComponent>
                    </HMS.PageListComponent>
                </HMS.LoadingComponent>
            </Fragment>
        );
    }

    selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode(option.props.children.toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    };
}

export default withTranslation()(TourTicketDetail);
